import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

export const IndentColumn = styled(Col)`
    border: none;
    flex: 0 0 8%;
`;

export const DataColumn = styled(Col)`
    border: none;
    padding: 0;
`;

export const WrapperClient = styled.div`
    display: flex;
`;

export const Wrapper = styled(Row)`
    padding: 0;
    margin: 0;

    background-color: ${(props) =>
        props.selected
            ? globalThis.config.colors.gray9
            : "#FCFCFC"};
    &:hover {
        background: ${(props) => !props.selected && globalThis.config.colors.gray9};
    }

    ${DataColumn} {
        border-bottom: ${globalThis.config.border.small};
    }
    &:first-child {
        ${DataColumn} {
            border-top: none;
        }
    }
    &:last-child {
        ${DataColumn} {
            border-bottom: none;
        }
    }

    &:hover .rightArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.black};
        }
    }
    &:hover .downArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.black};
        }
    }

    .rightArrow {
        path,
        circle {
            stroke: ${globalThis.config.colors.gray3};
        }
    }
`;

export const ClientLabel = styled.span`
    margin-top: -1px;
    font-size: 10px;
    font-family: ${globalThis.config.fonts.families.regular};
    font-weight: 400;
`;

export const ButtonWrapper = styled.div`
    position: absolute;
    left: -1.875rem;
    top: -0.2rem;
`;

export const ToggleButtonOpen = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;

export const ToggleButtonClosed = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
`;

export const ClientLabelWrapper = styled.div`
    margin-top: -2px;
`;
